import {Pipe, PipeTransform} from '@angular/core';



@Pipe({name: 'schoolFilter'})
export class SchoolFilterPipe implements PipeTransform {
    transform(itemsSchool: any[], argsSchool: String): any {
        return itemsSchool.filter(itemSchool => !argsSchool || itemSchool.master.masterSchoolUai === argsSchool);
    }
}

@Pipe({name: 'regionFilter'})
export class RegionFilterPipe implements PipeTransform {
    transform(itemsRegion: any[], argsRegion: String): any {
        return itemsRegion.filter(itemRegion => !argsRegion || itemRegion.master.academicRegionLabel.trim() === argsRegion.trim());
    }
}

@Pipe({name: 'statusFilter'})
export class StatusFilterPipe implements PipeTransform {
    transform(items: any[], args: string[]): any {
        return items.filter(item => !args || args.indexOf(item.status) !== -1);
    }
}

@Pipe({name: 'replaceLineBreaks'})
export class ReplaceLineBreaks implements PipeTransform {
    transform(value: string): string {
        let newValue = value.replace(/\n/g, '<br/>');
        return `${newValue}`;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/utils/statusFilter.pipe.ts